import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setModalOpen } from "../../store/modalSlice";

interface PersonaNudgeModalProps {
  onClose?: () => void;
}

const PersonaNudgeModal: React.FC<PersonaNudgeModalProps> = ({ onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAccept = () => {
    dispatch(setModalOpen(false));
    navigate("/onboarding-v2");
  };

  const handleDecline = () => {
    dispatch(setModalOpen(false));
  };

  return (
    <div className="flex flex-col items-center text-center px-6 py-8 gap-5">
      <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
        <svg
          className="w-6 h-6 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      </div>

      <h2 className="text-lg font-semibold text-gray-900">
        Improve Your AI Responses
      </h2>

      <p className="text-sm text-gray-600 max-w-sm">
        Responses improve when we understand what you're trying to achieve.
        Build out your persona to get more relevant, tailored insights.
      </p>

      <div className="flex gap-3 mt-2">
        <button
          onClick={handleDecline}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
        >
          Maybe Later
        </button>
        <button
          onClick={handleAccept}
          className="px-4 py-2 text-sm font-medium text-white bg-eai-primary-accent rounded-md hover:bg-eai-accent-dk transition-colors"
        >
          Build My Persona
        </button>
      </div>
    </div>
  );
};

export default PersonaNudgeModal;
